import { rtkApi } from '@/z-shared/api';
import type { ReducersMapObject } from '@reduxjs/toolkit';
import { combineSlices } from '@reduxjs/toolkit';
import type { LazyStateSchema, PrimaryStateSchema } from './stateSchema';

const primaryReducers: ReducersMapObject<PrimaryStateSchema> = {
    [rtkApi.reducerPath]: rtkApi.reducer,
};

export const rootReducer = combineSlices(primaryReducers)
    .withLazyLoadedSlices<LazyStateSchema>();
